(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react-dom"), require("react"), require("tether"));
	else if(typeof define === 'function' && define.amd)
		define(["react-dom", "react", "tether"], factory);
	else if(typeof exports === 'object')
		exports["TetherComponent"] = factory(require("react-dom"), require("react"), require("tether"));
	else
		root["TetherComponent"] = factory(root["ReactDOM"], root["React"], root["Tether"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__, __WEBPACK_EXTERNAL_MODULE__3__) {
return 